import { render, staticRenderFns } from "./BtnImport.vue?vue&type=template&id=171729ff"
import script from "./BtnImport.vue?vue&type=script&lang=js"
export * from "./BtnImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports